import React, { Component } from 'react';
import { Link } from 'react-router-dom'

import {
	Menu,
	Button,
	Container
} from 'semantic-ui-react';

class MainMenu extends Component 
{
	render() {
		let pathName = window.location.pathname;
		return (
			<div>
				<Menu fixed='top' size='large'>
					<Container>
						<Link to='/'><Menu.Item as='a' active={pathName === '/'}>Home</Menu.Item></Link>
						<Link to='/gridcaster'><Menu.Item as='a' active={pathName === '/gridcaster'}>Games</Menu.Item></Link>
						<Link to='/about'><Menu.Item as='a' active={pathName === '/about'}>About</Menu.Item></Link>
						<Menu.Menu position='right'>
							<Link to='/press'>
								<Menu.Item as='a' active={pathName === '/press'}>
									Press
								</Menu.Item>
							</Link>
						</Menu.Menu>
					</Container>
				</Menu>
			</div>
		);
	}
}

export default MainMenu;



// WEBPACK FOOTER //
// ./src/MainMenu.js